import { useTranslation } from "react-i18next"
import { useTeams, useUsers } from "@/hooks"
import type { TSession } from "@/types"

export function PreviewUsers({
  user_ids,
  team_ids = [],
  method: _method,
  fallback,
}: {
  team_ids?: string[]
  user_ids?: string[]
  method?: TSession["population"]
  fallback?: string
}) {
  const { t } = useTranslation()
  const { findTeam } = useTeams()
  const teams = team_ids.map((team_id) => findTeam(team_id)).filter(Boolean)

  const users = useUsers().users.filter((u) => user_ids?.includes(u.id))

  const parts: string[] = []
  if (teams.length) parts.push(teams.map((team) => team!.name).join(", "))
  if (users.length) parts.push(users.map((u) => u.full_name).join(", "))

  if (parts.length) return parts.join(", ")

  return fallback ?? t("All employees")
}
